import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { AnalticsService } from '@teem/app/core/services/analtics.service';
import { messages as i18n } from '@teem/constants/messages';
@Component({
	selector: 'app-storefront-analytics',
	templateUrl: './storefront-analytics.component.html',
	styleUrls: ['./storefront-analytics.component.scss']
})
export class StorefrontAnalyticsComponent implements OnInit {
	@ViewChild('datepickerGrid') datepickerGrid!: ElementRef;
	@ViewChild('startDayInput') startDayInput!: ElementRef<HTMLInputElement>;
	@ViewChild('endDayInput') endDayInput!: ElementRef<HTMLInputElement>;

	constructor(
		protected analticsService: AnalticsService,
		private renderer: Renderer2,
	) {
		this.generateDateOptions();
	}

	ngAfterViewInit(): void {
		this.updateCalendar();
	}

	isDropdownOpen = false;
	selectedOption = 'Option 1';
	options = ['Option 1', 'Option 2'];
	mostPopularProducts: any = [];
	leastPopularProducts: any = [];
	topOrderingCustomers: any = [];
	promocodeAnalytics: any = [];
	abandonedCart : any = [];
	topDistrict : any = [];
	markers: any = [];
	influencerData: any = [];
	currencySymbol: any = [];
	selectedStartDate: Date | null = null;
	selectedEndDate: Date | null = null;

	currentDate = new Date();
	isSelectingEndDate = false;
	activeDropdown: HTMLElement | null = null;
	selectedText: string = i18n.dashboard.select_an_option;
	selectedDateRange: string = '';
	dateOptions: { label: string, range: string }[] = [];
	monthNames: string[] = [
		"January", "February", "March", "April", "May", "June",
		"July", "August", "September", "October", "November", "December"
	];

	toggleDropdown() {
		this.isDropdownOpen = !this.isDropdownOpen;
	}


	generateDateOptions() {
		const today = new Date();

		const formatDate = (date: Date) =>
			date.toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' });

		// const getPastDate = (days: number) => {
		//     const pastDate = new Date();
		//     pastDate.setDate(today.getDate() - days);
		//     return pastDate;
		// };

		const getPastDate = (days: number) => {
			const now = new Date();
			now.setDate(today.getDate() - days);
			const dayOfWeek = now.getDay(); // 0 for Sunday, 6 for Saturday
			const startOfWeek = new Date(now);
			startOfWeek.setDate(now.getDate() - dayOfWeek); // Move back to Sunday
			// startOfWeek.setHours(0, 0, 0, 0); // Reset time

			// const endOfWeek = new Date(startOfWeek);
			// endOfWeek.setDate(startOfWeek.getDate() + 6); // Move forward to Saturday
			// endOfWeek.setHours(23, 59, 59, 999); // Set to end of the day

			return startOfWeek;
		}

		const getThisWeeksSaturday = (days: number) => {
			const today = new Date();
			today.setDate(today.getDate() - days);
			const dayOfWeek = today.getDay();
			const daysUntilSaturday = 6 - dayOfWeek;
			today.setDate(today.getDate() + daysUntilSaturday);
			return today;
		}

		const getMonthStart = (monthOffset: number): Date => {
			return new Date(today.getFullYear(), today.getMonth() - monthOffset, 1);
		};

		// Helper function to get the last day of a specific month (monthOffset)
		const getMonthEnd = (monthOffset: number): Date => {
			const firstDayOfMonth: Date = new Date(today.getFullYear(), today.getMonth() - monthOffset, 1);
			return new Date(firstDayOfMonth.getFullYear(), firstDayOfMonth.getMonth() + 1, 0);
		};

		function getYesterdayDate(): Date {
			const today: Date = new Date();
			today.setDate(today.getDate() - 1); // Subtract one day from today's date
			return today;
		}

		this.dateOptions = [
			{ label: i18n.dashboard.today, range: `${formatDate(today)} - ${formatDate(today)}` },
			{ label: i18n.dashboard.yesterday, range: `${formatDate(getYesterdayDate())} - ${formatDate(today)}` },
			{ label: i18n.dashboard.this_week, range: `${formatDate(getPastDate(0))} - ${formatDate(getThisWeeksSaturday(0))}` },
			{ label: i18n.dashboard.last_week, range: `${formatDate(getPastDate(7))} - ${formatDate(getThisWeeksSaturday(7))}` },
			{ label: i18n.dashboard.last_two_weeks, range: `${formatDate(getPastDate(14))} - ${formatDate(getThisWeeksSaturday(7))}` },
			{ label: i18n.dashboard.this_month, range: `${formatDate(getMonthStart(0))} - ${formatDate(getMonthEnd(0))}` },
			{ label: i18n.dashboard.last_month, range: `${formatDate(getMonthStart(1))} - ${formatDate(getMonthEnd(1))}` },
			{ label: i18n.dashboard.last_three_month, range: `${formatDate(getMonthStart(3))} - ${formatDate(getMonthEnd(1))}` }
		];
	}

	toggleCalendar(event: Event): void {
		const button = event.target as HTMLElement;
		const dropdownContainer = button.closest('.custom_select');
		const dropdownMenu = dropdownContainer.querySelector('.custom_select-content');
		const allDropdowns = document.querySelectorAll('.custom_select-content');
		const allContainers = document.querySelectorAll('.custom_select');

		allDropdowns.forEach((dropdown) => {
			if (dropdown !== dropdownMenu) {
				this.renderer.setStyle(dropdown, 'display', 'none');
			}
		});

		allContainers.forEach((container) => {
			if (container !== dropdownContainer) {
				this.renderer.removeClass(container, 'active');
			}
		});

		const isDropdownVisible = dropdownMenu.getAttribute('style') === 'display: block;';

		this.renderer.setStyle(dropdownMenu, 'display', isDropdownVisible ? 'none' : 'block');

		if (isDropdownVisible) {
			this.renderer.removeClass(dropdownContainer, 'active');
		} else {
			this.renderer.addClass(dropdownContainer, 'active');
		}
	}

	selectOption(option: string) {
		this.selectedOption = option;
		this.isDropdownOpen = false;
	}

	ngOnInit(): void {
		this.getDashboardBlockData();
	}

	onImgError(item: any) {
		item.img = 'images/no-image.png';
	}

	applyDateRange() {
		if (this.selectedStartDate && this.selectedEndDate) {
			this.cancelDataPicker();
		}
		this.getDashboardBlockData();
	}

	cancelDataPicker() {
		document.getElementById('custom_datepicker-popup')?.classList.add('hidden');
	}

	openDataPicker() {
		document.getElementById('custom_datepicker-popup')?.classList.remove('hidden');
	}

	updateCalendar() {
		const grid = this.datepickerGrid.nativeElement;
		grid.innerHTML = '';

		const firstDay = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1);
		const lastDay = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0);
		const daysInMonth = lastDay.getDate();
		const startDay = firstDay.getDay() //firstDay.getDay() === 0 ? 6 : firstDay.getDay() - 1;

		for (let i = 0; i < startDay; i++) {
			const emptyCell = document.createElement('div');
			grid.appendChild(emptyCell);
		}

		for (let day = 1; day <= daysInMonth; day++) {
			const dayElement = document.createElement('div');
			dayElement.textContent = `${day}`;
			dayElement.classList.add('calendar-day');

			dayElement.addEventListener('click', () => this.handleDateSelection(day, dayElement));

			grid.appendChild(dayElement);
		}

		this.highlightRange();
	}

	handleDateSelection(day: number, element: HTMLElement) {
		const selectedDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), day);

		if (!this.selectedStartDate || (this.selectedStartDate && this.selectedEndDate)) {
			this.selectedStartDate = selectedDate;
			this.selectedEndDate = null;
			this.isSelectingEndDate = true;
			this.clearSelection();
			element.classList.add('selected-date');
		} else if (this.isSelectingEndDate) {
			if (selectedDate < this.selectedStartDate) {
				this.selectedEndDate = this.selectedStartDate;
				this.selectedStartDate = selectedDate;
			} else {
				this.selectedEndDate = selectedDate;
			}
			this.isSelectingEndDate = false;
		}

		this.highlightRange();
		this.updateInputs();
	}

	highlightRange() {
		const grid = this.datepickerGrid.nativeElement;
		const days = grid.querySelectorAll('.calendar-day');

		days.forEach((dayElement: any) => {
			const dayNumber = parseInt(dayElement.textContent, 10);
			const date = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), dayNumber);

			dayElement.classList.remove('selected-range', 'selected-date');

			if (this.selectedStartDate && date.getTime() === this.selectedStartDate.getTime()) {
				dayElement.classList.add('selected-date');
			}

			if (this.selectedEndDate && date.getTime() === this.selectedEndDate.getTime()) {
				dayElement.classList.add('selected-date');
			}

			if (this.selectedStartDate && this.selectedEndDate &&
				date > this.selectedStartDate && date < this.selectedEndDate) {
				dayElement.classList.add('selected-range');
			}
		});
	}


	updateInputs() {
		if (this.selectedStartDate) {
			this.startDayInput.nativeElement.value = this.selectedStartDate.toLocaleDateString('en-US');
		}
		if (this.selectedEndDate) {
			this.endDayInput.nativeElement.value = this.selectedEndDate.toLocaleDateString('en-US');
		}
	}

	clearSelection() {
		const grid = this.datepickerGrid.nativeElement;
		grid.querySelectorAll('.calendar-day').forEach((day: any) => {
			day.classList.remove('selected-date', 'selected-range');
		});
	}

	selectItem(event: Event, option: { label: string, range: string }): void {
		const selectedElement = event.target as HTMLElement;
		this.selectedText = selectedElement.innerText.trim();

		if (option) {

			const [startDateStr, endDateStr] = option.range.split(' - ');

			const startDate = new Date(startDateStr);
			const endDate = new Date(endDateStr);

			if (startDate && endDate && startDate <= endDate) {
				this.selectedStartDate = startDate;
				this.selectedEndDate = endDate;
			}

			this.getDashboardBlockData();
		}

		const activeDropdowns = document.querySelectorAll('.custom_select.active');
		activeDropdowns.forEach((dropdown) => {
			this.renderer.removeClass(dropdown, 'active');
			const dropdownMenu = dropdown.querySelector('.custom_select-content') as HTMLElement;
			if (dropdownMenu) {
				this.renderer.setStyle(dropdownMenu, 'display', 'none');
			}
		});

		this.activeDropdown = null;
	}

	getDashboardBlockData(): void {
		this.analticsService.get({
			'start_date':this.formatDateLocal(this.selectedStartDate),
			'end_date':this.formatDateLocal(this.selectedEndDate)
		}).subscribe(
			(response: any) => {
				this.mostPopularProducts = response.top_popular;
				this.leastPopularProducts = response.top_unpopular;
				this.topOrderingCustomers = response.top_customer;
				this.promocodeAnalytics = response.active_promocodes;
				this.abandonedCart = response.abandoned_cart;
				this.topDistrict = response.district_data;
				this.markers = response.marker;
				this.influencerData = response.influencer_data;
				this.currencySymbol = response.currency_symbol;
			},
			(error) => {
				console.error('Error fetching data', error); // Handle errors
			}
		);
	}

	formatDateLocal(date: Date | null): string {
	if (!date) return ''; // or return some default date string if required
	const pad = (n: number) => n.toString().padStart(2, '0');
	return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}
}
